import React, { useState, useContext, useEffect } from 'react';
import Box from '@mui/material/Box'
import { Typography, useMediaQuery } from '@mui/material';
import { Grid } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MDButton from 'components/MDButton';
import { DataGrid } from '@mui/x-data-grid';
import { CheckCircleOutline, GradingRounded, KeyboardReturnRounded, MoreVertOutlined, RemoveCircleOutline, CheckCircle, Warning, Error, Info } from '@mui/icons-material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import { useApi, useSucursales } from "lib/api";

function Recepciondocumentos(props) {
  const { post } = useApi();
  const sucursales = useSucursales();
  const [currentsucursal, setCurrentSucursal] = useState(localStorage.getItem("sucursal"))
  const [transferencias, setTransferencias] = useState([])
  const [transferenciasSeleccionadas, setTransferenciasSeleccionadas] = useState([])
  const [filaSeleccionada, setFilaSeleccionada] = useState(null)
  const [botonesDesactivados, setBotonesDesactivados] = useState(new Set())
  const [comentario, setComentario] = useState('')
  const [procesando, setProcesando] = useState(false)
  
  // Estados para el diálogo de notificaciones
  const [dialogOpen, setDialogOpen] = useState(false)
  const [dialogTitle, setDialogTitle] = useState('')
  const [dialogMessage, setDialogMessage] = useState('')
  const [dialogType, setDialogType] = useState('info')

  // Función para mostrar diálogo de notificación
  const showDialog = (title, message, type = 'info') => {
    setDialogTitle(title);
    setDialogMessage(message);
    setDialogType(type);
    setDialogOpen(true);
  };

  // Función para cerrar el diálogo
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  // Cargar transferencias de documentos pendientes
  const cargarTransferencias = async () => {
    const { status, data } = await post('/api/getlotetransf', {
      'sucursal': currentsucursal,
      'tipo': 'documentos'
    })
    if (status === 200) {
      setTransferencias(data["motor"] || []);
      console.log(data["motor"])
    } else if (status === 400) {
      showDialog('Error de Conexión', data["Error"], 'error');
    }
  };

  // Cargar transferencias al montar el componente
  useEffect(() => {
    cargarTransferencias();
  }, [currentsucursal]);

  // Columnas para la tabla de transferencias
  const columns = [
    {
      field: 'idtransaccion',
      headerName: 'ID Transacción',
      width: 200,
    },
    {
      field: 'stransmisor',
      headerName: 'Sucursal Origen',
      width: 150,
    },
    {
      field: 'fechatransm',
      headerName: 'Fecha Envío',
      width: 150,
    },
    {
      field: 'transportista',
      headerName: 'Transportista',
      width: 150,
    },
    {
      field: 'documento',
      headerName: 'Tipos de Documentos',
      width: 200,
      renderCell: (params) => {
        const tipos = params.value ? params.value.split(',') : [];
        return (
          <Box>
            {tipos.map((tipo, index) => (
              <Typography key={index} variant="caption" style={{
                backgroundColor: '#e3f2fd',
                color: 'red',
                padding: '2px 8px',
                borderRadius: '12px',
                margin: '2px',
                display: 'inline-block',
                fontSize: '20px'
              }}>
                {tipo.replace('"', '')}
              </Typography>
            ))}
          </Box>
        );
      }
    },
    {
      field: 'chasis',
      headerName: 'Chasis',
      width: 200,
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 120,
      renderCell: (params) => (
        <MDButton 
          variant="gradient" 
          color="success" 
          size="small"
          disabled={botonesDesactivados.has(params.row.idtransaccion)}
          onClick={() => {
            setBotonesDesactivados(prev => new Set([...prev, params.row.idtransaccion]));
            procesarRecepcion(params.row);
          }}
        >
          Recibir
        </MDButton>
      ),
    },
    {
      field: 'actions1',
      headerName: 'Acciones',
      width: 120,
      renderCell: (params) => (
        <MDButton 
          variant="gradient" 
          color="error" 
          size="small"
          disabled={botonesDesactivados.has(params.row.idtransaccion)}
          onClick={() => {
            setBotonesDesactivados(prev => new Set([...prev, params.row.idtransaccion]));
            procesarRechazo(params.row);
          }}
        >
          Rechazar
        </MDButton>
      ),
    },
  ];

  // Procesar recepción de documentos
  const procesarRecepcion = async (transferencia) => {
    console.log("manueljr1",transferencia)
    try {
      const { status, data } = await post('/api/transferenciabackend_procesarrecepciondocumentos', {
        'sucursal': currentsucursal,
        'documentos': [transferencia],
        'comentario': comentario,
        'tipo': 'documentos'
      })
      if (status === 200) {
          showDialog('Recepción Exitosa', 'Documentos recibidos correctamente', 'success');

          // Actualizar la tabla inmediatamente removiendo la transferencia procesada
          setTransferencias(prevTransferencias =>
            prevTransferencias.filter(t => t.idtransaccion !== transferencia.idtransaccion)
          );

          // También recargar desde el servidor para asegurar consistencia
          setTimeout(() => {
            cargarTransferencias();
          }, 1000);

          setComentario(''); // Limpiar comentario
          setFilaSeleccionada(null); // Limpiar selección
          // El botón ya está desactivado, no necesitamos hacer nada más
      }
      if (status === 400) {
          showDialog('Error en Recepción', data["Error"], 'error');
          // En caso de error, reactivar el botón
          setBotonesDesactivados(prev => {
            const newSet = new Set(prev);
            newSet.delete(transferencia.idtransaccion);
            return newSet;
          });
      }
    } catch (error) {
      showDialog('Error de Conexión', 'No se pudo conectar con el servidor', 'error');
      // En caso de error, reactivar el botón
      setBotonesDesactivados(prev => {
        const newSet = new Set(prev);
        newSet.delete(transferencia.idtransaccion);
        return newSet;
      });
    }
  };


  // Procesar rechazo de documentos
  const procesarRechazo = async (transferencia) => {
    try {
      const respuesta = await post('/api/transferenciabackend_procesarrechazodocumentos', {
        'sucursal': currentsucursal,
        'documentos': [transferencia],
        'comentario': comentario,
        'tipo': 'documentos'
      })
      console.log("manueljr2",respuesta)
      const { status, data } = respuesta
      if (status === 200) {
          showDialog('Recepción Exitosa', 'Documentos devueltos correctamente', 'success');

          // Actualizar la tabla inmediatamente removiendo la transferencia procesada
          setTransferencias(prevTransferencias =>
            prevTransferencias.filter(t => t.idtransaccion !== transferencia.idtransaccion)
          );

          // También recargar desde el servidor para asegurar consistencia
          setTimeout(() => {
            cargarTransferencias();
          }, 1000);

          setComentario(''); // Limpiar comentario
          setFilaSeleccionada(null); // Limpiar selección
          // El botón ya está desactivado, no necesitamos hacer nada más
      }
      if (status === 400) {
          showDialog('Error en Recepción', data["Error"], 'error');
          // En caso de error, reactivar el botón
          setBotonesDesactivados(prev => {
            const newSet = new Set(prev);
            newSet.delete(transferencia.idtransaccion);
            return newSet;
          });
      }
    } catch (error) {
      showDialog('Error de Conexión', 'No se pudo conectar con el servidor', 'error');
      // En caso de error, reactivar el botón
      setBotonesDesactivados(prev => {
        const newSet = new Set(prev);
        newSet.delete(transferencia.idtransaccion);
        return newSet;
      });
    }
  };

  // Componente de diálogo personalizado
  const CustomDialog = () => {
    const getIcon = () => {
      switch(dialogType) {
        case 'success':
          return <CheckCircle style={{color: '#4caf50', fontSize: 48}} />;
        case 'warning':
          return <Warning style={{color: '#ff9800', fontSize: 48}} />;
        case 'error':
          return <Error style={{color: '#f44336', fontSize: 48}} />;
        default:
          return <Info style={{color: '#2196f3', fontSize: 48}} />;
      }
    };

    const getColor = () => {
      switch(dialogType) {
        case 'success':
          return '#4caf50';
        case 'warning':
          return '#ff9800';
        case 'error':
          return '#f44336';
        default:
          return '#2196f3';
      }
    };

    return (
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="custom-dialog-title"
        aria-describedby="custom-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="custom-dialog-title" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          color: getColor()
        }}>
          {getIcon()}
          {dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="custom-dialog-description" style={{fontSize: '16px', lineHeight: '1.5'}}>
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{padding: '16px 24px'}}>
          <Button 
            onClick={handleDialogClose} 
            variant="contained"
            style={{
              backgroundColor: getColor(),
              color: 'white',
              minWidth: '100px'
            }}
            autoFocus
          >
            Aceptar
          </Button>

          
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <Box>
      <Grid container spacing={2} style={{marginTop:"15px"}}>
        <Grid item xs={12} sm={12} md={12} lg={12} marginTop={3}>
          <Typography variant="h4" style={{marginBottom:"10px"}}>
            Recepción de Documentos
          </Typography>
          <Typography variant="body1" style={{marginBottom:"20px", color:"#666"}}>
            Gestiona la recepción de documentos transferidos desde otras sucursales.
          </Typography>
        </Grid>

        {/* Información de sucursal */}
        <Grid item xs={12} sm={12} md={6} lg={6} style={{backgroundColor:"white", padding:"20px", marginBottom:"20px"}}>
          <Typography variant="h6" style={{marginBottom:"20px"}}>
            Información de Recepción
          </Typography>
          
          <Box style={{marginBottom:"20px"}}>
            <Typography variant="body1" style={{fontWeight:"bold", marginBottom:"10px"}}>
              Sucursal de Destino:
            </Typography>
            <Box style={{
              padding:"15px",
              backgroundColor:"#e8f5e8",
              borderRadius:"8px",
              border:"1px solid #4caf50"
            }}>
              <Typography variant="h6" style={{color:"#2e7d32"}}>
                {currentsucursal || 'Sucursal Actual'}
              </Typography>
              <Typography variant="body2" style={{color:"#666", marginTop:"5px"}}>
                Esta es la sucursal donde se recibirán los documentos
              </Typography>
            </Box>
          </Box>

          <Box style={{
            padding:"15px",
            backgroundColor:"#f5f5f5",
            borderRadius:"8px",
            border:"1px solid #ddd"
          }}>
            <Typography variant="body2" style={{fontWeight:"bold", marginBottom:"10px"}}>
              Detalles de la Recepción:
            </Typography>
            <Typography variant="body2" style={{color:"#666", marginBottom:"5px"}}>
              • Fecha: {new Date().toLocaleDateString()}
            </Typography>
            <Typography variant="body2" style={{color:"#666", marginBottom:"5px"}}>
              • Hora: {new Date().toLocaleTimeString()}
            </Typography>
            <Typography variant="body2" style={{color:"#666", marginBottom:"5px"}}>
              • Usuario: {localStorage.getItem('usuario') || 'Usuario actual'}
            </Typography>
            <Typography variant="body2" style={{color:"#666"}}>
              • Los documentos se marcarán como recibidos en esta sucursal.
            </Typography>
          </Box>
        </Grid>

        {/* Campo de comentarios */}
        <Grid item xs={12} sm={12} md={6} lg={6} style={{backgroundColor:"white", padding:"20px", marginBottom:"20px"}}>
          <Typography variant="h6" style={{marginBottom:"20px"}}>
            Comentarios de Recepción
          </Typography>
          
          <TextField
            fullWidth
            label="Comentarios sobre la recepción"
            value={comentario}
            onChange={(event) => setComentario(event.target.value)}
            variant="standard"
            multiline
            rows={4}
            sx={{boxShadow: 4, borderRadius: 2, backgroundColor: "white"}}
            InputLabelProps={{
              shrink: "true",
              style:{
                paddingLeft: "10px",
                paddingTop: "5px",
              }
            }}
            InputProps={{
              disableUnderline:true,
              borderRadius:5,
              style:{
                fontSize: "14px",
                marginLeft: "5px",
                marginTop: "20px",  
              }}}
          />
        </Grid>

        {/* Tabla de transferencias */}
        <Grid item xs={12} style={{backgroundColor:"white", padding:"20px"}}>
          <Box style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"20px"}}>
            <Typography variant="h6">
              Transferencias Pendientes de Recepción
            </Typography>
            <MDButton 
              variant="gradient" 
              color="info" 
              onClick={cargarTransferencias}
            >
              Actualizar Lista
            </MDButton>
          </Box>
          
          <Box style={{ height: 400, width: '100%' }}>
            <DataGrid
              rows={transferencias}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10, 25, 50]}
              checkboxSelection={false}
              disableSelectionOnClick={false}
              onRowClick={(params) => setFilaSeleccionada(params.row)}
              getRowId={(row) => row.id}
              getRowClassName={(params) => 
                filaSeleccionada?.id === params.id ? 'selected-row' : ''
              }
            />
          </Box>
        </Grid>
      </Grid>

      {/* Diálogo personalizado para notificaciones */}
      <CustomDialog />
    </Box>
  );
}

export default Recepciondocumentos;
